import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const FEATURE = 'ai-photo-improving';

/** Файлы, которые мы считаем медиа */
export const mediaFileTypes: string[] = getFeature('media-file-types') || ['png', 'jpg', 'jpeg', 'heic'];

/** Настройки оплаты */
export const aiPhotoImprovingThreeTariffsPopupTitle: string =
    getFeature('ai-photo-improving-tariffs-popup-title') || 'Нейросеть улучшит фото — с подпиской Mail Space';
export const aiPhotoImprovingBillingPopupTitle: string =
    getFeature('ai-photo-improving-billing-popup-title') || 'Mail Space: улучшение фото с нейросетью';
export const aiPhotoImprovingThreeTariffsListId: string = getFeature('ai-photo-improving-tariffs-list-id') || '23';

/** id промо баннера - для включения нужно будет включать фичу 3promo-enable-{PROMO_BANNER_ID} */
export const PROMO_BANNER_ID = `${FEATURE}-banner`;
/** Ключ для локалстораджа */
export const storageKeyForBanner = `${PROMO_BANNER_ID}-2`;
/** Временной промежуток между показами одной и той же промки, в секундах */
export const showIntervalBanner: number = +getFeature(`${PROMO_BANNER_ID}-show-interval`) || 172800;
/** Максимальное количество закрытий промки (на крестик в баннере / на primary кнопку) */
export const closeLimitBanner: number = +getFeature(`${PROMO_BANNER_ID}-close-limit`) || 3;
/** Максимальное количество показов, в которых не взаимодействуют с промкой */
export const showLimitBanner: number = +getFeature(`${PROMO_BANNER_ID}-show-limit`) || 3;

/** id промо модалки - для включения нужно будет включать фичу 3promo-enable-{PROMO_MODAL_ID} */
export const PROMO_MODAL_ID = `${FEATURE}-modal`;
/** Ключ для локалстораджа */
export const storageKeyForModal = `${PROMO_MODAL_ID}-2`;
/** Временной промежуток между показами одной и той же промки, в секундах */
export const showIntervalModal: number = +getFeature(`${PROMO_MODAL_ID}-show-interval`) || 172800;
/** Максимальное количество закрытий промки (на крестик в баннере / на primary кнопку) */
export const closeLimitModal: number = +getFeature(`${PROMO_MODAL_ID}-close-limit`) || 3;
/** Максимальное количество показов, в которых не взаимодействуют с промкой */
export const showLimitModal: number = +getFeature(`${PROMO_MODAL_ID}-show-limit`) || 3;

/** Ключ для локалстораджа от тултипа */
export const storageKeyForTooltips = `${FEATURE}-tooltips-data`;
/** Показывать ли иконки с тултипами в списке файлов/просмотрщике */
export const isShowAiTooltipOnMediaFilesFeature: boolean = !!getFeature(`${FEATURE}-show-tooltips`);
/** Сколько раз показываем иконки с тултипами */
export const maxCountShowAiTooltipOnMediaFiles: number = +getFeature(`${FEATURE}-tooltips-max-count-show`) || 3;
/** Временной промежуток между показами тултипов */
export const showIntervalTooltip: number = +getFeature(`${FEATURE}-tooltips-show-interval`) || 172800;
